import { useEffect, useState } from "react";

import { getConfigs } from "app/utils/configs";
import { isHttpUrl } from "app/utils/url";

export function useCubejsConfig(): string | null {
  const [apiUrl, setApiUrl] = useState<string | null>(null);

  useEffect(() => {
    async function fetchConfig() {
      const configs = await getConfigs();

      const domain = configs.cubejs.cubejs_domain;
      if (!domain) {
        // No cube configured (e.g. local-dev without `just local-cube`); leave
        // the URL unset so dashboards stay inert rather than erroring.
        return;
      }
      if (isHttpUrl(domain)) {
        // Absolute URL (local-dev talks to cube directly): derive the ws
        // scheme from it -- ws:// for the plain-HTTP local cube, wss:// for TLS.
        const u = new URL(domain);
        const scheme = u.protocol === "https:" ? "wss" : "ws";
        setApiUrl(`${scheme}://${u.host}/cubejs-api/v1`);
      } else if (domain.startsWith("/")) {
        // Path-relative domain: connect back to the page's own host.
        const scheme = window.location.protocol === "https:" ? "wss" : "ws";
        setApiUrl(`${scheme}://${window.location.host}${domain}/cubejs-api/v1`);
      } else {
        // Bare domain (deployed): always TLS.
        setApiUrl(`wss://${domain}/cubejs-api/v1`);
      }
    }

    if (!apiUrl) {
      fetchConfig();
    }
  }, [apiUrl, setApiUrl]);

  return apiUrl;
}
